module.exports = __webpack_public_path__ + "img/制御工学5_1_4.b9066924.png";